module.exports = __webpack_public_path__ + "static/img/event20.28ecc00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event20.png
// module id = bUmS
// module chunks = 1